import { shallow } from 'zustand/shallow';

import { webAppSettingsStore, webAppSettingsStoreTemp } from './WebAppSettingsStore';

function selectWebAppSettings(state) {
  return { settings: state };
}

export function useWebAppSettings() {
  return webAppSettingsStore.store(selectWebAppSettings, shallow);
}

function selectFullscreen(state) {
  return {
    isFullscreen: state.isFullscreen,
  };
}

export function useIsFullscreen() {
  return webAppSettingsStoreTemp.store(selectFullscreen, shallow);
}
